import styled from "styled-components";

export const MusicPracticeRoomStep1ContainerStyled = styled.div`
  padding: 20px 20px 46px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .music_practice_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .header_layout {
      margin-bottom: 32px;
    }
    .header_backhome_layout {
      margin-bottom: 32px;
    }
    .title_preview {
      margin-bottom: 28px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .btn_confirm_wrap {
      margin: auto;
      margin-top: 20px;
      max-width: 294px;
    }
    .detail_layout {
      margin-bottom: 28px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 0px 20px 46px 20px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
